import * as React from 'react';
import { GridContext, GridContextGridProps } from './GridContext';
import { RowProps } from '../row/Row';
import { StyledGridDiv } from './styledGridDiv';

export interface GridProps extends GridContextGridProps {
  children: React.ReactElement<RowProps> | React.ReactElement<RowProps>[];
}

const Grid: React.SFC<GridProps> = ({ children, columnGap, columns }) => {
  return (
    <GridContext.Provider value={{ columnGap, columns }}>
      <StyledGridDiv>{children}</StyledGridDiv>
    </GridContext.Provider>
  );
};

export default Grid;
